import angular from 'angular';
import uiRouter from 'angular-ui-router';
import ViewComponent from './view.component';
import routing from './view.routes';

export default angular
  .module('verifyApp.cases.view', [uiRouter])
  .config(routing)
  .component('view', ViewComponent)
  .name;



// WEBPACK FOOTER //
// ./client/app/cases/view/index.js